<template>
  <comp-facebook :account="account" />
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import utils from '@/services/utils'
  import CompFacebook from './Facebook'
  export default {
    components: {
      CompFacebook
    },
    props: {
      data: {
        type: Object,
        required: true,
        default: null,
      },
    },
    data: () => ({
      account: null
    }),
    watch: {
      'data.FacebookAccount': {
        handler: function (newValue) {
          this.account = newValue ? newValue : null
        },
        deep: true
      }
    },
    computed: {
      ...mapState('app', ['locale', 'FontContent', 'FontSizeContent', 'ColorContent']),
    },
    mounted () {
      this.account = this.data.FacebookAccount ? this.data.FacebookAccount : null
    }
  }
</script>
<style scoped>
</style>
